import {
    validateAge,
    validateAlphaNumericStringAllowingOnlyNumbers,
    validateAlphaNumericStringLenient,
    validateEmail,
    validateNumber,
    validateNumericString,
    validateSingleSelection,
    validateTime,
} from '@om/validation';
import { setOtherDetailsFieldValid } from '../../../actions/allSureMotorClaim/otherDetails';
import { getOtherDetailsForm } from '../../../selectors/allSureMotorClaim/otherDetails';
import { validateDate, validateDateBW, ValidateYear } from '@om/validation/src/validators/date-validator';
import { getIncidentDetailsForm } from '../../../selectors/allSureMotorClaim/incidentDetails';
import { validateAlphaNumericStringAllowingOnlyNumbersWithSpecial } from '@om/validation/src/validators/string-validator';
let prevValidationAction = null;

export const otherDetailsValidations = (store, next, action) => {
    const state = store.getState();
    const { dateOfIncident, driverLicense } = getOtherDetailsForm(state);

    const { dateOfAccident } = getIncidentDetailsForm(state);

    const getTomorrowDate = () => {
        const currentDate = new Date();
        currentDate.setDate(currentDate.getDate());
        const day = currentDate.getDate();
        const month = currentDate.getMonth() + 1;
        const year = currentDate.getFullYear();
        return `${day}/${month}/${year}`;
    };
 const validateDateFormat=(value)=>{
        if(!value){
            return null
        }
    else  return value.length===10 ? null : "Oops, you need to enter a valid date in the dd/mm/yyyy format"
    }
    const getLessThanThreeYears = () => {
        const currentDate = new Date();
        currentDate.setDate(currentDate.getDate());
        const day = currentDate.getDate();
        const month = currentDate.getMonth() + 1;
        const year = currentDate.getFullYear() - 3;
        return `${day}/${month}/${year}`;
    };

    const todayDate = dateOfIncident?.value && dateOfIncident?.value;

    const calculateDaysFromDate = (incidentDate) => {
        const [day, month, year] = incidentDate.split('/').map(Number);
        const incident = new Date(year, month - 1, day);
        const currentDate = new Date();
        const timeDiff = currentDate - incident;
        const days = Math.floor(timeDiff / (1000 * 60 * 60 * 24));
        return days;
    };

    const driverAge = () => {
        if (['Learner', 'Full'].includes(driverLicense?.value)) {
            return 18;
        } else {
            return 2;
        }
    };
    const validationAction = (() => {
        let error;
        const fieldType = action.fieldType || action.value?.fieldType;
        const isWitnessName = /^witnessName_\d+$/;
        const isWitnessPhone = /^witnessPhone_\d+$/;
        const isWitnessAddress = /^witnessAddress_\d+$/;

        if (isWitnessName.test(fieldType)) {
            error = validateAlphaNumericStringLenient(action.value.value, {
                min: 2,
                max: 50,
                required: false,
                subject: 'witness name',
            });
        } else if (isWitnessPhone.test(fieldType)) {
            error = validateNumericString(action.value.value, {
                min: 6,
                max: 8,
                required: false,
                subject: 'witness telephone number',
            });
        } else if (isWitnessAddress.test(fieldType)) {
            error = validateAlphaNumericStringLenient(action.value.value, {
                min: 2,
                max: 100,
                required: false,
                subject: 'witness address',
            });
        } else {
            switch (action.value.fieldType) {
                case 'description':
                    error = validateAlphaNumericStringLenient(action.value.value, {
                        min: 2,
                        max: 500,
                        required: true,
                        subject: 'description of broken glass',
                    });
                    break;
                case 'windScreenSize':
                    error = validateSingleSelection(action.value.value, 'option');
                    break;
                case 'brokenGlass':
                    error = validateSingleSelection(action.value.value, 'option');
                    break;
                case 'crackOrShattered':
                    error = validateAlphaNumericStringLenient(action.value.value, {
                        min: 2,
                        max: 500,
                        required: true,
                        subject: 'windscreen cracked or completely shattered. If other, please specify.',
                    });
                    break;

                case 'dateOfIncident':
                    error =validateDateFormat(action.value.value) ?? validateDateBW(action.value.value, {
                        min: getLessThanThreeYears(),
                        max: getTomorrowDate(),
                        selectable: true,
                        subject: 'date of theft',
                        required: true,
                    });
                    break;
                case 'reasonForDelay':
                    error = validateAlphaNumericStringLenient(action.value.value, {
                        min: 25,
                        max: 2500,
                        required: true,
                        subject: 'reason for late notification',
                    });
                    break;
                case 'timeOfIncident':
                    error = validateTime(action.value.value, {
                        date: todayDate,
                        subject: 'time of theft',
                        required: true,
                    });
                    break;
                case 'placeWhereTheftOccurred':
                    error = validateAlphaNumericStringLenient(action.value.value, {
                        min: 2,
                        max: 100,
                        subject: 'place where theft occurred',
                        required: true,
                    });
                    break;
                case 'policeStationReportedTo':
                    error = validateAlphaNumericStringLenient(action.value.value, {
                        min: 2,
                        max: 100,
                        subject: 'police station reported to',
                        required: true,
                    });
                    break;
                case 'sapsCaseNumber':
                    error = validateAlphaNumericStringLenient(action.value.value, {
                        min: 2,
                        max: 50,
                        subject: 'police case number',
                        required: true,
                    });
                    break;
                case 'dateReported':
                    error = validateDateFormat(action.value.value) ?? validateDateBW(action.value.value, {
                        min: dateOfIncident?.value,
                        max: getTomorrowDate(),
                        selectable: true,
                        subject: 'date reported',
                        required: true,
                    });
                    break;
                case 'reportedBy':
                    error = validateAlphaNumericStringLenient(action.value.value, {
                        min: 2,
                        max: 50,
                        subject: 'reported by',
                        required: true,
                    });
                    break;

                case 'circumstancesOfTheft':
                    error = validateAlphaNumericStringLenient(action.value.value, {
                        min: 2,
                        max: 500,
                        subject: 'circumstances of theft',
                        required: true,
                    });
                    break;
                case 'vehicleLocked':
                    error = validateSingleSelection(action.value.value, 'option');
                    break;
                case 'reasonOfLock':
                    error = validateAlphaNumericStringLenient(action.value.value, {
                        min: 2,
                        max: 500,
                        subject: 'reason for vehicle not locked',
                        required: true,
                    });
                    break;
                case 'detailsStolenAccessories':
                    error = validateAlphaNumericStringLenient(action.value.value, {
                        min: 2,
                        max: 500,
                        subject: 'details of stolen accessories',
                        required: false,
                    });
                    break;
                case 'associateSecured':
                    error = validateSingleSelection(action.value.value, 'option');
                    break;
                case 'antiTheft':
                    error = validateSingleSelection(action.value.value, 'option');
                    break;
                case 'make':
                    error = validateAlphaNumericStringLenient(action.value.value, {
                        min: 2,
                        max: 50,
                        subject: 'make',
                        required: false,
                    });
                    break;
                case 'dateFitted':
                    error = validateDateFormat(action.value.value) ?? validateDate(action.value.value, {
                        max: getTomorrowDate(),
                        selectable: true,
                        subject: 'fitted date',
                        required: false,
                    });
                    break;
                case 'fittedBy':
                    error = validateAlphaNumericStringLenient(action.value.value, {
                        min: 2,
                        max: 50,
                        subject: 'fitted by',
                        required: false,
                    });
                    break;
                case 'windowNumber':
                    error = validateAlphaNumericStringLenient(action.value.value, {
                        min: 2,
                        max: 50,
                        subject: 'number',
                        required: false,
                    });
                    break;
                case 'appliedByWhom':
                    error = validateAlphaNumericStringLenient(action.value.value, {
                        min: 2,
                        max: 50,
                        subject: 'applied by whom',
                        required: false,
                    });
                    break;
                case 'detailsOfDents':
                    error = validateAlphaNumericStringLenient(action.value.value, {
                        min: 2,
                        max: 500,
                        subject: 'details of scratches, dents, defects',
                        required: true,
                    });
                    break;
                case 'detailsOfOtherFeatures':
                    error = validateAlphaNumericStringLenient(action.value.value, {
                        min: 2,
                        max: 500,
                        subject: 'details of other features which would assist identification',
                        required: true,
                    });
                    break;

                case 'nameOfPoliceOfficer':
                    error = validateAlphaNumericStringLenient(action.value.value, {
                        min: 2,
                        max: 50,
                        subject: 'name of police officer',
                        required: true,
                    });
                    break;
                case 'stationName':
                    error = validateAlphaNumericStringLenient(action.value.value, {
                        min: 2,
                        max: 50,
                        subject: 'station name',
                        required: true,
                    });
                    break;
                case 'referenceNumber':
                    error = validateAlphaNumericStringAllowingOnlyNumbers(action.value.value, {
                        min: 2,
                        max: 100,
                        subject: 'reference number',
                        required: true,
                    });
                    break;
                case 'dateOfReported':
                    error = validateDateFormat(action.value.value) ?? validateDateBW(action.value.value, {
                        min: dateOfAccident?.value,
                        max: getTomorrowDate(),
                        selectable: true,
                        subject: 'date reported',
                        required: true,
                    });
                    break;
                case 'testedAlcohol':
                    error = validateSingleSelection(action.value.value, 'option');
                    break;
                case 'descriptionOfAccident':
                    error = validateAlphaNumericStringLenient(action.value.value, {
                        min: 2,
                        max: 500,
                        subject: 'description of accident',
                        required: true,
                    });
                    break;
                case 'parked':
                    error = validateSingleSelection(action.value.value, 'option');
                    break;
                case 'driverName':
                    error = validateAlphaNumericStringLenient(action.value.value, {
                        min: 2,
                        max: 50,
                        subject: 'driver’s name',
                        required: true,
                    });
                    break;
                case 'driverIdNumber':
                    error = validateAlphaNumericStringAllowingOnlyNumbers(action.value.value, {
                        min: 2,
                        max: 50,
                        subject: 'driver’s ID number',
                        required: true,
                    });
                    break;
                case 'driverAge':
                    error = validateAge(action.value.value, {
                        min: driverAge(),
                        max: 150,
                        subject: 'driver’s age',
                        required: true,
                    });
                    break;
                case 'driverLicense':
                    error = validateSingleSelection(action.value.value, 'option');
                    break;
                case 'driverLicenseNumber':
                    error = validateAlphaNumericStringAllowingOnlyNumbers(action.value.value, {
                        min: 2,
                        max: 50,
                        subject: 'driver’s licence number',
                        required: true,
                    });
                    break;
                case 'driverLicenseCode':
                    error = validateSingleSelection(action.value.value, 'option');
                    break;
                case 'vehicleUse':
                    error = validateAlphaNumericStringLenient(action.value.value, {
                        min: 2,
                        max: 500,
                        subject: 'purpose for which the vehicle was being used',
                        required: true,
                    });
                    break;
                case 'driverOwner':
                    error = validateSingleSelection(action.value.value, 'option');
                    break;
                case 'drivingPermission':
                    error = validateSingleSelection(action.value.value, 'option');
                    break;
                case 'employee':
                    error = validateSingleSelection(action.value.value, 'option');
                    break;
                // case 'ownerOfOtherVehicle':
                //     error = validateSingleSelection(action.value.value, 'option');
                //     break;
                case 'nameOfInsurer':
                    error = validateAlphaNumericStringLenient(action.value.value, {
                        min: 2,
                        max: 50,
                        subject: 'name of insurer',
                        required: true,
                    });
                    break;
                case 'policyNumber':
                    error = validateAlphaNumericStringAllowingOnlyNumbers(action.value.value, {
                        min: 2,
                        max: 30,
                        subject: 'policy number',
                        required: true,
                    });
                    break;
                case 'convictionsDetails':
                    error = validateAlphaNumericStringLenient(action.value.value, {
                        min: 2,
                        max: 500,
                        subject: 'details of any convictions for motoring offences',
                        required: true,
                    });
                    break;
                case 'licenseEndorse':
                    error = validateSingleSelection(action.value.value, 'option');
                    break;
                case 'physicalDefects':
                    error = validateSingleSelection(action.value.value, 'option');
                    break;
                case 'previousAccidentDetails':
                    error = validateAlphaNumericStringLenient(action.value.value, {
                        min: 2,
                        max: 500,
                        subject: 'details of previous accidents',
                        required: true,
                    });
                    break;

                case 'thirdParty':
                    error = validateSingleSelection(action.value.value, 'option');
                    break;
                case 'thirdPartyMake':
                    error = validateAlphaNumericStringLenient(action.value.value, {
                        min: 2,
                        max: 50,
                        subject: 'third party vehicle make',
                        required: false,
                    });
                    break;
                case 'thirdPartyRegistrationNumber':
                    error = validateAlphaNumericStringAllowingOnlyNumbers(action.value.value, {
                        min: 2,
                        max: 50,
                        subject: 'third party registration number',
                        required: false,
                    });
                    break;
                case 'thirdPartyNameOfOwner':
                    error = validateAlphaNumericStringLenient(action.value.value, {
                        min: 2,
                        max: 50,
                        subject: 'third party owner’s name',
                        required: false,
                    });
                    break;
                case 'thirdPartyAddressOfOwner':
                    error = validateAlphaNumericStringLenient(action.value.value, {
                        min: 2,
                        max: 100,
                        subject: 'third party owner’s address',
                        required: false,
                    });
                    break;
                case 'thirdPartyDriverName':
                    error = validateAlphaNumericStringLenient(action.value.value, {
                        min: 2,
                        max: 50,
                        subject: 'third party driver’s name',
                        required: false,
                    });
                    break;
                case 'thirdPartyAddressOfDriver':
                    error = validateAlphaNumericStringLenient(action.value.value, {
                        min: 2,
                        max: 100,
                        subject: 'third party driver’s address',
                        required: false,
                    });
                    break;
                case 'thirdPartyEmailDriver':
                    error = validateAlphaNumericStringAllowingOnlyNumbersWithSpecial(action.value.value, {
                        min: 5,
                        max: 60,
                        subject: 'third party email, telephone/cellphone number',
                        required: false,
                    });
                    break;
                case 'thirdPartyInsuranceCompanyName':
                    error = validateAlphaNumericStringLenient(action.value.value, {
                        min: 2,
                        max: 50,
                        subject: 'third party insurance company name',
                        required: false,
                    });
                    break;
                case 'thirdPartyPolicyNumber':
                    error = validateAlphaNumericStringAllowingOnlyNumbers(action.value.value, {
                        min: 2,
                        max: 30,
                        subject: 'third party policy number',
                        required: false,
                    });
                    break;
                case 'anyOtherProperty':
                    error = validateSingleSelection(action.value.value, 'option');
                    break;
                case 'detailOfDamageProperty':
                    error = validateSingleSelection(action.value.value, 'option');
                    break;
                case 'nameOfOwner':
                    error = validateAlphaNumericStringLenient(action.value.value, {
                        min: 2,
                        max: 50,
                        subject: 'owner’s name',
                        required: false,
                    });
                    break;
                case 'addressOfOwner':
                    error = validateAlphaNumericStringLenient(action.value.value, {
                        min: 2,
                        max: 100,
                        subject: 'owner’s address',
                        required: false,
                    });
                    break;
                case 'detailsDamage':
                    error = validateAlphaNumericStringLenient(action.value.value, {
                        min: 2,
                        max: 500,
                        subject: 'details of damage',
                        required: false,
                    });
                    break;
                case 'outSidePersonalInjuries':
                    error = validateSingleSelection(action.value.value, 'option');
                    break;
                // case 'detailsOfInjuries':
                //     error = validateSingleSelection(action.value.value, 'option');
                //     break;

                case 'nameOfInjured':
                    error = validateAlphaNumericStringLenient(action.value.value, {
                        min: 2,
                        max: 50,
                        subject: 'injured name',
                        required: false,
                    });
                    break;
                case 'nameOfHospital':
                    error = validateAlphaNumericStringLenient(action.value.value, {
                        min: 2,
                        max: 50,
                        subject: 'hospital name',
                        required: false,
                    });
                    break;
                case 'detailsOfInjury':
                    error = validateAlphaNumericStringLenient(action.value.value, {
                        min: 2,
                        max: 500,
                        subject: 'details of injury',
                        required: false,
                    });
                    break;
                case 'relationShipToAccident':
                    error = validateAlphaNumericStringLenient(action.value.value, {
                        min: 2,
                        max: 50,
                        subject: 'relationship to accident',
                        required: false,
                    });
                    break;
                case 'witness':
                    error = validateSingleSelection(action.value.value, 'option');
                    break;

                default:
                    return null;
            }
        }

        return setOtherDetailsFieldValid(error, action.value.fieldType);
    })();

    if (!validationAction) {
        return next(action);
    }

    store.dispatch(validationAction);
    prevValidationAction = validationAction;
    return next(action);
};
